import { Suspense } from 'react'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'

import '@loadsmart/miranda-react/dist/styles/variables.css'

import { SettingsProvider } from '@loadsmart/react-frontend-settings'
import { SettingsValue } from '@loadsmart/react-frontend-settings/dist/context/provider'

import { BASE_API_URL } from 'core/infra/environment'
import { HttpClient } from 'core/infra/http/HttpClient'
import Fallback from 'core/ui/components/Fallback'
import { ToastContainer } from 'core/ui/components/ToastContainer'
import { useInitApplication } from 'core/ui/hooks/useInitApplication'
import Router from 'core/ui/Router'

const queryClient = new QueryClient()

async function getSettings(): Promise<SettingsValue> {
  const httpClient = new HttpClient(BASE_API_URL)
  const { data } = await httpClient.get<SettingsValue>('/fe-settings')
  return data
}

const App = () => {
  useInitApplication()

  return (
    <QueryClientProvider client={queryClient}>
      <SettingsProvider getSettings={getSettings} options={{ autoUpdate: false }}>
        <BrowserRouter>
          <Suspense fallback={<Fallback />}>
            <Router />
            <ToastContainer />
          </Suspense>
        </BrowserRouter>
      </SettingsProvider>
    </QueryClientProvider>
  )
}

export default App
